import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Shield, Users, Mountain, Home as HomeIcon, Package, Heart, Sprout, Leaf, UsersRound } from 'lucide-react';

const categories = [
  { slug: 'families', icon: HomeIcon, title: 'Families', desc: 'Healthy snacks & meals', image: 'https://images.unsplash.com/photo-1606787366850-de6330128bfc?w=400' },
  { slug: 'growers', icon: Sprout, title: 'Growers', desc: 'Preserve your harvest', image: 'https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?w=400' },
  { slug: 'adventurers', icon: Mountain, title: 'Adventurers', desc: 'Lightweight trail meals', image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=400' },
  { slug: 'emergency-prep', icon: Shield, title: 'Resilient Living', desc: '25+ year food storage', image: 'https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?w=400' },
  { slug: 'pet-lovers', icon: Heart, title: 'Pet Wellness', desc: 'Premium pet treats', image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400' },
  { slug: 'healthy-living', icon: Star, title: 'Clean Eating', desc: 'Maximum nutrition', image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400' },
  { slug: 'homesteaders', icon: Users, title: 'Country Living', desc: 'Food independence', image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=400' },
  { slug: 'entrepreneurs', icon: Package, title: 'Entrepreneurs', desc: 'Start a food business', image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400' },
  { slug: 'dietary-restrictions', icon: Leaf, title: 'Dietary Restrictions', desc: 'Allergen-free options', image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400' },
  { slug: 'community-groups', icon: UsersRound, title: 'Community Groups', desc: 'Churches & organizations', image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=400' }
];

export const LifestyleCategories = () => {
  return (
    <section className="py-20 bg-[#f0f4f8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0a0203] mb-4">
            For Every Lifestyle
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Whether you're preserving your garden harvest, creating healthy snacks for your family, or building an emergency food supply - there's a HomeLyph for you.
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {categories.map((cat, i) => (
            <Link key={i} to={`/lifestyle/${cat.slug}`} className="group relative overflow-hidden rounded-2xl h-48 md:h-56 card-hover">
              <img src={cat.image} alt={cat.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0203]/90 via-[#0a0203]/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <cat.icon className="h-4 w-4 text-[#fdc31c]" />
                  <h3 className="text-sm md:text-base font-bold text-white">{cat.title}</h3>
                </div>
                <p className="text-white/70 text-xs mb-2">{cat.desc}</p>
                <span className="text-[#fdc31c] text-xs font-medium group-hover:underline">Learn More →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LifestyleCategories;
